import moment from 'moment';

const useChatLastMessageDate = (date: Date | null): string => {
  if (date === null) return '';
  const now = moment();
  if (moment(date).isSame(now, 'day')) {
    return moment(date).format('LT');
  } else if (moment(date).diff(now, 'day') > -7) {
    return moment(date).format('dd');
  } else {
    return moment(date).format('L');
  }
};

export default useChatLastMessageDate;
